module.exports = __webpack_public_path__ + "static/media/trip-4.c0f5ed7f.png";